import { render, staticRenderFns } from "./ftp-list.vue?vue&type=template&id=68e646c9&scoped=true"
import script from "./ftp-list.vue?vue&type=script&lang=js"
export * from "./ftp-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e646c9",
  null
  
)

export default component.exports